module.exports = __webpack_public_path__ + "static/screenshot-5f009bb3091ac41d2f6afbe1885da1fe.png";